import { useMemo } from 'react';
import { useBlueberryStageReport } from '../../../../../../services/data/reports/hooks/useBlueberryStageReport';
import { StrictDateRange } from '../../../../../commonUI/DateRangeFilterSelect/types';
import { useRawCountStages } from './useRawCountStages';

export const useBlueberryColorRawCounts = (
  customerId: string | undefined,
  dateRange: StrictDateRange | undefined
) => {
  const stages = useRawCountStages();

  const {
    data: blueberryStageReportData,
    isLoading: isBlueberryStageReportLoading,
  } = useBlueberryStageReport(customerId, stages, dateRange);

  // add stage name and order to the raw counts
  const rawCounts = useMemo(() => {
    return blueberryStageReportData?.map((item) => {
      const stage = stages.find((stage) => stage.id === item.stage_id);
      return {
        ...item,
        stage_name: stage?.name || 'Unknown Stage',
        order: stage?.order,
      };
    });
  }, [blueberryStageReportData, stages]);

  return {
    rawCounts,
    isRawCountsLoading: isBlueberryStageReportLoading,
  };
};
